import { useRef, useMemo } from 'react'
import JoditEditor from 'jodit-react'
 
const NewsletterEditor = ({ value, onChange }) => {
  const editor = useRef(null)
 
  const config = useMemo(() => ({
    height: 480,
    toolbarSticky: false,
    uploader: { insertImageAsBase64URI: true },
    enableDragAndDropFileToEditor: true,
    saveIndicator: false,
    statusbar: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultMode: 1,
    buttons: [
      'source', '|',
      'bold', 'italic', 'underline', 'strikethrough', '|',
      'ul', 'ol', '|',
      'font', 'fontsize', 'brush', '|',
      'paragraph', 'align', '|',
      'image', 'link', '|',
      'undo', 'redo', '|',
      'hr', 'table', '|',
      'fullsize'
    ],
    showCharsCounter: true,
    showWordsCounter: true,
    showXPathInStatusbar: false,
    toolbarAdaptive: false,
    readonly: false,
    enter: 'P',
    tabIndex: 1
  }), []) // Empty dependency array since config doesn't depend on props
 
  return (
    <>
      <JoditEditor
        ref={editor}
        value={value}
        config={config}
        tabIndex={1}
        onBlur={newContent => onChange(newContent)} // preferred to use onBlur
        onChange={newContent => {}}
      />
    </>
  )
}
 
export default NewsletterEditor